import { cn } from '@/lib/utils'

type Props = {
  eyebrow?: string
  title: string
  subtitle?: string
  className?: string
}

// Shared homepage section header: a small kicker, the section title, an accent
// underline and an optional subtitle — centered and RTL-safe. Presentational
// only, so it can be used from both server and client sections.
const SectionHeading = ({ eyebrow, title, subtitle, className }: Props) => (
  <header className={cn('mx-auto max-w-2xl space-y-4 text-center', className)}>
    {eyebrow ? (
      <p className='text-xl font-bold uppercase tracking-[0.2em] text-tertiary-light md:text-2xl'>{eyebrow}</p>
    ) : null}
    <h2 className='h2 font-bold text-tertiary-lightFonts'>{title}</h2>
    <span className='mx-auto block h-1 w-16 rounded-full bg-tertiary-lightFonts' />
    {subtitle ? <p className='text-lg font-light text-white/80'>{subtitle}</p> : null}
  </header>
)

export default SectionHeading
